import { useQuery } from "@tanstack/react-query";
import { getUserRequests } from "../services/get-user-requests";
import {
  UserRequestSort,
  UserRequestStatus,
  UserRequestType,
} from "../types/user-request";
import { useRegionFilter } from "@/features/regions/hooks/use-region-filter";

export function useUserRequests(params: {
  page?: number;
  limit?: number;
  type?: UserRequestType;
  status?: UserRequestStatus;
  date_from?: string;
  date_to?: string;
  q?: string;
  sort?: UserRequestSort;
}) {
  const region = useRegionFilter();
  const paramsWithRegion = { ...params, region };

  return useQuery({
    queryKey: ["user-requests", paramsWithRegion],
    queryFn: () => getUserRequests(paramsWithRegion),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 2,
  });
}
